<template>
  <div>
    <div class="search-panel">
      <slot name="btn"></slot>
      <template>
        <a-input :disabled="!!queryParam.patientName" class="search-item-com" v-model="queryParam.input" placeholder="请输入编号/姓名" style="width: 400px"></a-input>        
        <a-button class="search-item-com" type="primary" @click="searchQueryMy">查询</a-button>
        <a-button class="search-item-com" @click="searchReset">重置</a-button>
        <a-button class="search-item-com"  @click="supperSearchView">高级筛选</a-button>
      </template>
    </div>
    <a-table
      ref="table"
      size="middle"
      :scroll="{x:'100%'}"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :rowSelection="selected?{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}:null"
      :loading="loading"
      @change="handleTableChange">
        <!-- <template slot="time" slot-scope="time">
          <a-range-picker valueFormat="YYYY-MM-DD" style="width:200px"/>
        </template> -->
        <span slot="action" slot-scope="text, record">
          <a @click="handleView(record)">查看</a>
        </span>
        <span slot="status" slot-scope="text, record, index">
          <status-tag :status="text"></status-tag>
        </span>
    </a-table>
    <a-modal
      title="高级筛选"
      :width="'70%'"
      :visible="advancedVisible"
      :footer="null"
      
      @cancel="handleAdvancedCancel"
      class="custom-modal">   
      
        <a-row class="spaced-row">
          <a-col :span="3" class="advanced-label">
            研究中心：
          </a-col>
          <a-col :span="7">
              <a-select v-model="queryParam2.centerIdList" placeholder="请选择研究中心" style='min-width: 200px'  mode="multiple" :filter-option="filterOption">
                <a-select-option :value="center.center.id" v-for="(center,index) in centerList" :key="index">
                  {{center.center.name}}
                </a-select-option>
              </a-select>
          </a-col>
          <a-col :span="3" class="advanced-label">
            研究员：
          </a-col>
          <a-col :span="11">
              <a-select v-model="queryParam2.personIdList" placeholder="请选择研究员" style='min-width: 200px'  mode="multiple" :filter-option="filterOption">
                <a-select-option :value="user.userId" v-for="(user,index) in userList" :key="index">
                  {{user.realname}}
                </a-select-option>
              </a-select>
          </a-col>
        </a-row>
        <a-row class="spaced-row">
          <a-col :span="3" class="advanced-label">
           受试者状态：
          </a-col>
          <a-col :span="7">
              <!-- <a-select v-model="queryParam2.groupIdList" placeholder="请选择组别" style='min-width: 200px'  mode="multiple" :filter-option="filterOption">
                <a-select-option :value="item.id" v-for="(item,index) in groupList" :key="index">
                  {{item.name}}
                </a-select-option>
              </a-select> -->
              <a-select v-model="queryParam2.patientStatus" placeholder="受试者状态" style='min-width: 150px' allow-clear >
                <a-select-option :value="item.value" v-for="(item,index) in patientStatusList" :key="index">
                  {{item.name}}
                </a-select-option>
              </a-select>
          </a-col>
          <a-col :span="3" class="advanced-label">
            注册日期：
          </a-col>
          <a-col :span="11">
              <a-range-picker v-model="queryParam2.createTimeList"  valueFormat="YYYY-MM-DD" style="width:200px"/>
          </a-col>
        </a-row>
        <a-row class="spaced-row">
          <a-col :span="3" class="advanced-label">
            通过筛选日期：
          </a-col>
          <a-col :span="7">
              <a-range-picker v-model="queryParam2.passDateList"  valueFormat="YYYY-MM-DD" style="width:200px"/>
          </a-col>
          <a-col :span="3" class="advanced-label">
            基点日期：
          </a-col>
          <a-col :span="11">
              <a-range-picker v-model="queryParam2.baseDateList"  valueFormat="YYYY-MM-DD" style="width:200px"/>
          </a-col>
        </a-row>
        <a-row class="spaced-row">          
          <a-col :span="3" class="advanced-label">
            周期：
          </a-col>
          <a-col :span="7">
              <a-select v-model="queryParam2.periodItemIdList" placeholder="请选择" style='min-width: 200px'  mode="multiple" :filter-option="filterOption">
                <a-select-option :value="periodItem.id" v-for="(periodItem,index) in periodItemList" :key="index">
                  {{periodItem.name}}
                </a-select-option>
              </a-select>
              <a-select v-model="queryParam2.periodStatus" placeholder="请选择周期状态" style='min-width: 150px' allow-clear >
                <a-select-option :value="item.value" v-for="(item,index) in periodStatusList" :key="index">
                  {{item.name}}
                </a-select-option>
              </a-select>
          </a-col>
          <a-col :span="3" class="advanced-label">
            表单：
          </a-col>
          <a-col :span="11">
              <a-select v-model="queryParam2.formId" placeholder="请选择表单" style='min-width: 200px' showSearch :filter-option="filterOption" allow-clear @change="formIdChange">
                <a-select-option :value="form.id" v-for="(form,index) in formList" :key="index">
                  {{form.name}}
                </a-select-option>
              </a-select>
              <a-select v-model="queryParam2.formStatus" placeholder="请选择表单状态" style='min-width: 150px' allow-clear >
                <a-select-option :value="item.value" v-for="(item,index) in formStatusList" :key="index">
                  {{item.name}}
                </a-select-option>
              </a-select>
          </a-col>
        </a-row>

        <a-row class="spaced-row">          
          <a-col :span="3" class="advanced-label">
            表单提交人：
          </a-col>
          <a-col :span="7">
              <a-select v-model="queryParam2.userId" placeholder="请选择" style='min-width: 200px'  allow-clear>
                <a-select-option :value="user.userId" v-for="(user,index) in userList" :key="index">
                  {{user.realname}}
                </a-select-option>
              </a-select>
          </a-col>
          <a-col :span="3" class="advanced-label">
            表单提交时间：
          </a-col>
          <a-col :span="11">
              <a-range-picker v-model="queryParam2.submitTimeList"  valueFormat="YYYY-MM-DD" style="width:200px"/>
          </a-col>
        </a-row>
        <div class="scrollable-content">   
          <a-row class="spaced-row" v-for="(item,index) in formItemList" :key="index">
            <form-view-item :form-item="item" :form.sync="formItemValue" v-if="item.scale!=='1' && item.conceal!=='1'" :key="index"></form-view-item>
          </a-row>
      </div>
      
      <div style="text-align: right">
        <a-button type="primary" @click="handleAdvancedSubmit">查询</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import FormViewItem from '@/views/project/components/FormViewItem'
  import StatusTag from '@/views/project/patient/components/StatusTag'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction ,postAction} from '@/api/manage'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'CheckFormQuery',
    mixins: [JeecgListMixin],
    components: { FormViewItem,StatusTag },
    props:{      
      selected:{
        type:Boolean,
        default:false,
      },
      baseQuery:{
        type:Object,
        default:()=>{
          return {}
        },
      }
    },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        advancedVisible:false,
        centerList:[],
        // centerListFilters:[],
        groupList:[],
        userList:[],
        periodItemList:[],
        formList:[],
        formItemList:[],
        queryParam2:{},
        formItemValue:{},
        selectPeriodName:'',
        selectPeriodStatus:'',
        selectUserName:'',
        //1未开始2暂存3数据缺失4已提交5已提交（失访）
        formStatusList:[{value:"1",name:"未开始"},{value:"2",name:"暂存"},{value:"3",name:"数据缺失"},{value:"4",name:"已提交"},{value:"5",name:"已提交（失访）"}],
        //1未到期2可随访3已过期4已完成
        periodStatusList:[{value:"1",name:"未到期"},{value:"2",name:"可随访"},{value:"3",name:"已过期"},{value:"4",name:"已完成"}],
        patientStatusList:[
          {value:'1',name:'筛选期'},
          {value:'2',name:'随访期'},
          {value:'3',name:'终止筛选'},
          {value:'4',name:'终止随访'},
          {value:'5',name:'随访完成'},
        ],
        columns: [
        {
          title: '受试者编号',
          fixed: 'left',
          align: 'center',
          width: 150,
          ellipsis: true,
          dataIndex: 'patientNum'
        },
        // {
        //   fixed: 'left',
        //   title: 'EID',
        //   align: 'center',
        //   width: 100,
        //   ellipsis: true,
        //   dataIndex: 'eid'
        // },
        {
          title: '受试者姓名',
          align: 'center',
          fixed: 'left',
          width: 150,
          ellipsis: true,
          key: 'name',
          dataIndex: 'name'
        },
        {
          title: '受试者信息',
          children: [
            {
              title: '性别',
              align: 'center',
              width: 80,
              ellipsis: true,
              key: 'sex',
              dataIndex: 'sex_dictText',
            },
            {
              title: '年龄',
              align: 'center',
              width: 80,
              ellipsis: true,
              dataIndex: 'age'
            },
          ]
        },
        {
          title: '入组信息',
          children: [
            {
              title: '研究中心',
              align: 'center',
              width: 200,
              ellipsis: true,
              dataIndex: 'centerName',
              // scopedSlots: { customRender: 'centerName' }
              filters: []//this.centerListFilters,
            },
            {
              title: '研究员',
              align: 'center',
              width: 100,
              ellipsis: true,
              dataIndex: 'personName',
              filters: []
            },
            {
              title: '受试者状态',
              align: 'center',
              width: 120,
              ellipsis: true,
              scopedSlots: { customRender: 'status' },
              dataIndex: 'status',
              filters: [
                {value:'1',text:'筛选期'},
                {value:'2',text:'随访期'},
                {value:'3',text:'终止筛选'},
                {value:'4',text:'终止随访'},
                {value:'5',text:'随访完成'},
              ],
              filterMultiple: false, // 设置为单选
              // defaultFilteredValue: ['3']
            },
            {
              title: '注册日期',
              align: 'center',
              width: 160,
              ellipsis: true,
              dataIndex: 'createTime',
              // scopedSlots: { customRender: 'time' },
              // filters: []
            },
            {
              title: '通过筛选日期',
              align: 'center',
              width: 140,
              ellipsis: true,
              dataIndex: 'passDate'
            },
            // {
            //   title: '组别',
            //   align: 'center',
            //   width: 100,
            //   ellipsis: true,
            //   dataIndex: 'groupName',
            //   filters: []
            // },
            {
              title: '基点日期',
              align: 'center',
              width: 100,
              ellipsis: true,
              dataIndex: 'baseDate'
            },
            // {
            //   title: '周期',
            //   align: 'center',
            //   width: 100,
            //   ellipsis: true,
            //   dataIndex: 'selectPeriodName'
            // },
            // {
            //   title: '周期状态',
            //   align: 'center',
            //   width: 100,
            //   ellipsis: true,
            //   dataIndex: 'selectPeriodStatus'
            // },
            // {
            //   title: '提交人',
            //   align: 'center',
            //   width: 100,
            //   ellipsis: true,
            //   dataIndex: 'selectUserName'
            // },
          ]
        },
      ],
        url:{
          list:'/patient/patient/supperList2'
        },
        disableMixinCreated:true,
      }
    },
    mounted(){
      this.columns.push({
          title: '操作',
          dataIndex: 'action',
          width: 120,
          align: "center",
          fixed:'right',
          scopedSlots: {customRender: 'action'}
        })
      this.baseQueryParam = Object.assign({projectId:this.projectId,checked:'0'},this.baseQuery)
      this.resetSupperParams()
      this.loadData()
      this.loadSearchData()
    },
    methods:{
      loadSearchData(){
        getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){            
            this.centerList = res.result
            if(res.result && res.result.length>0){
              this.columns[4].children[0].filters = res.result.map(center=>({"text":center.center.name,"value":center.center.id}))
            }            
          }
        })
        getAction('/project/projectUser/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.userList = res.result
            if(res.result && res.result.length>0){
              this.columns[4].children[1].filters = res.result.map(user=>({"text":user.realname,"value":user.userId}))
            }
          }
        })
        getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
          }
        })
        getAction('/project/projectForm/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.formList=res.result
          }
        })
        getAction('/project/projectGroup/list',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.groupList = res.result
            // if(res.result && res.result.length>0){
            //   this.columns[4].children[5].filters = res.result.map(user=>({"text":user.name,"value":user.id}))
            // }
          }
        })
      },
      loadDataCallback(){
        let that = this
        this.dataSource.forEach(function (item) {
          item.selectPeriodName = that.selectPeriodName
          item.selectPeriodStatus = that.selectPeriodStatus
          item.selectUserName = that.selectUserName
        });
      },

      resetSupperParams(){
        this.queryParam2={}
        // this.$set(this.queryParam2,'centerIdList',[])
        // this.$set(this.queryParam2,'personIdList',[])
        // this.$set(this.queryParam2,'userId',null)
        // this.$set(this.queryParam2,'periodItemIdList',[])
        // this.$set(this.queryParam2,'formId',null)
        // this.$set(this.queryParam2,'submitTimeList',[])
        // this.$set(this.queryParam2,'formStatus',null)
        this.$set(this.queryParam,'supper',"")
      },
      searchQueryMy(){
        this.resetSupperParams()
        this.searchQuery()
      },
      handleView(record){
        // this.$router.push({path:'/project/datacheck/checkform/'+record.id})
        this.$router.push({path:'/project/patient/registerview/'+record.id})
      },
      handleAdvancedSubmit(){
        let that= this
        // console.log("this.formItemValue:"+this.formItemValue)        
        this.$set(this.queryParam,'patientName',null)
        this.$set(this.queryParam,'patientId',null)
        this.$set(this.queryParam,'input',null)
        this.$set(this.queryParam2,'formItemValue',this.formItemValue)
        this.$set(this.queryParam,'supper',JSON.stringify(this.queryParam2))

        that.selectPeriodName = ''
        if(this.queryParam2.periodItemIdList!=null && this.queryParam2.periodItemIdList.length>0){
          this.queryParam2.periodItemIdList.forEach(function (value) {
            let period = that.periodItemList.find(item => item.id === value);
            if(period){
              that.selectPeriodName += " " + period.name;
            }
          });
        }
        that.selectUserName = ''
        if(this.queryParam2.userId){
          let user = this.userList.find(item => item.userId === this.queryParam2.userId);
            if(user){
              that.selectUserName = user.realname;
            }
        }
        that.selectPeriodStatus = ''
        if(this.queryParam2.periodStatus){
          let status = this.periodStatusList.find(item => item.value === this.queryParam2.periodStatus);
            if(status){
              that.selectPeriodStatus = status.name;
            }
        }
        // this.initFiltersValue()
        
        this.loadData();
        this.handleAdvancedCancel()
      },
      handleAdvancedCancel(){
        this.advancedVisible = false
      },
      supperSearchView(){
        // this.resetSupperParams()
        this.advancedVisible = true
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      formIdChange(){
        if(!this.queryParam2.formId){
          this.formItemList = []
          this.formItemValue={}
          return
        }        
        getAction('/project/projectForm/getInfoById',{id:this.queryParam2.formId}).then(res=>{
          if(res.success){
            this.formItemList = res.result.formItemList
            // console.log("formItemList:"+ this.formItemList)
          }
        })
      },
      handleTableChange(pagination, filters, sorter) {
        console.log("filters:"+ filters)
        let filterParam = this.queryParam2        
        if(filters["groupName"]){
          // this.queryParam2.groupIdList = filters["groupName"]
          this.$set(filterParam,'groupIdList',filters["groupName"])
        }
        if(filters["centerName"]){          
          // this.queryParam2.centerIdList = filters["centerName"]
          this.$set(filterParam,'centerIdList',filters["centerName"])
        }
        if(filters["personName"]){
          // this.queryParam2.personIdList = filters["personName"]
          this.$set(filterParam,'personIdList',filters["personName"])
        }
        if(filters["status"]){
          // this.queryParam2.patientStatus = filters["status"].length>0?filters["status"][0]:''
          this.$set(filterParam,'patientStatus',filters["status"].length>0?filters["status"][0]:'')
        }

        this.$set(this.queryParam,'supper',JSON.stringify(filterParam))
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadData();
      },
      initFiltersValue(){        
        this.columns[4].children[2].defaultFilteredValue = [this.queryParam2.patientStatus]
      },
    }
  }
</script>

<style scoped lang="less">
  .search-panel{
    text-align: left;
    margin-bottom: 10px;
    padding: 10px;
  }
  .search-item-com{
    margin-left: 5px;
  }
  .advanced-label{
    text-align: right;
  }
  .advanced-row{
    width: 100%;
    margin-bottom: 20px;
  }
  .spaced-row {
    margin-bottom: 16px;
  }
  .custom-modal .ant-modal-body {
    max-height: 400px; 
    overflow-y: auto; 
  }

  .scrollable-content {
    max-height: 350px; 
    overflow-y: auto; 
  }
</style>